var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-text-field", {
    attrs: {
      value: _vm.readonly && !_vm.Model ? _vm.value : _vm.Model,
      label: _vm.label,
      type: "text",
      dense: _vm.dense,
      prefix: _vm.prefix,
      "prepend-icon": _vm.prependIcon,
      readonly: _vm.readonly,
      "error-count": _vm.errorCount(_vm.keyError),
      "error-messages": _vm.errors(_vm.keyError),
      error: _vm.hasErrors(_vm.keyError),
      "hide-details": "auto",
    },
    on: {
      input: function ($event) {
        return _vm.updateValue($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }